import { createRouteRef, createApiRef, createPlugin, createApiFactory, discoveryApiRef, fetchApiRef, createRoutableExtension } from '@backstage/core-plugin-api';
import { PROJECT_KEY_NAME } from '@axis-backstage/plugin-jira-dashboard-common';
import { ResponseError } from '@backstage/errors';
import { parseEntityRef, DEFAULT_NAMESPACE } from '@backstage/catalog-model';

const rootRouteRef = createRouteRef({
  id: "jira-dashboard"
});

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class JiraDashboardClient {
  constructor(options) {
    __publicField(this, "discoveryApi");
    __publicField(this, "fetchApi");
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }
  async getJiraResponseByEntity(entityRef) {
    const apiUrl = await this.discoveryApi.getBaseUrl("jira-dashboard");
    const { kind, name, namespace } = parseEntityRef(entityRef, {
      defaultNamespace: DEFAULT_NAMESPACE
    });
    const resp = await this.fetchApi.fetch(
      `${apiUrl}/dashboards/by-entity-ref/${kind}/${namespace}/${name}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    if (!resp.ok)
      throw await ResponseError.fromResponse(resp);
    return resp.json();
  }
  async getProjectAvatar(entityRef) {
    const apiUrl = await this.discoveryApi.getBaseUrl("jira-dashboard");
    const { kind, name, namespace } = parseEntityRef(entityRef, {
      defaultNamespace: DEFAULT_NAMESPACE
    });
    return `${apiUrl}/avatar/by-entity-ref/${kind}/${namespace}/${name}`;
  }
}

const jiraDashboardApiRef = createApiRef({
  id: "plugin.jira-dashboard"
});

const isJiraDashboardAvailable = (entity, annotationPrefix) => {
  var _a;
  return Boolean(
    (_a = entity.metadata.annotations) == null ? void 0 : _a[`${annotationPrefix != null ? annotationPrefix : "jira.com"}/${PROJECT_KEY_NAME}`]
  );
};
const jiraDashboardPlugin = createPlugin({
  id: "jira-dashboard",
  apis: [
    createApiFactory({
      api: jiraDashboardApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new JiraDashboardClient({ discoveryApi, fetchApi })
    })
  ],
  routes: {
    root: rootRouteRef
  }
});
const EntityJiraDashboardContent = jiraDashboardPlugin.provide(
  createRoutableExtension({
    name: "EntityJiraDashboardContent",
    component: () => import('./index-DCYdNs5w.esm.js').then(
      (m) => m.JiraDashboardContent
    ),
    mountPoint: rootRouteRef
  })
);

export { EntityJiraDashboardContent as E, jiraDashboardPlugin as a, isJiraDashboardAvailable as i, jiraDashboardApiRef as j };
//# sourceMappingURL=index-B6H-xuSv.esm.js.map
